import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n/LanguageContext";
import { SparkoLogo } from "../SparkoLogo";
import { Icon } from "../common";
import { CONTACT, whatsappLink } from "../../data/site";

export const Footer = () => {
  const { t } = useLang();
  const quick = [["about", "/about"], ["services", "/services"], ["projects", "/projects"], ["gallery", "/gallery"], ["reviews", "/reviews"], ["faq", "/faq"]];
  const services = [
    ["Office Cleaning", "/services/office-cleaning"], ["Carpet Cleaning", "/services/carpet-cleaning"],
    ["Deep Cleaning", "/services/deep-cleaning"], ["Floor Care", "/services?cat=floor"],
    ["Industrial Cleaning", "/services/industrial-cleaning"], ["Eco-Friendly Cleaning", "/services/eco-friendly-cleaning"],
  ];
  return (
    <footer className="relative bg-navy text-white/80 grain overflow-hidden" data-testid="site-footer">
      <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <SparkoLogo dark={false} size={30} tagline />
            <p className="mt-5 max-w-xs leading-relaxed text-white/70">{t.footer.tagline}</p>
            <div className="mt-6 flex gap-3">
              {[["Facebook", "#"], ["Instagram", "#"], ["Linkedin", "#"], ["Twitter", "#"]].map(([ic, href]) => (
                <a key={ic} href={href} aria-label={ic} className="grid place-items-center h-10 w-10 rounded-full border border-white/15 hover:bg-blue hover:border-blue transition-colors">
                  <Icon name={ic} size={17} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-display text-white text-sm uppercase tracking-wider mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2.5 text-sm">
              {quick.map(([k, p]) => <li key={k}><Link to={p} className="hover:text-blue transition-colors">{t.nav[k]}</Link></li>)}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-white text-sm uppercase tracking-wider mb-4">{t.footer.ourServices}</h4>
            <ul className="space-y-2.5 text-sm">
              {services.map(([label, p]) => <li key={label}><Link to={p} className="hover:text-blue transition-colors">{label}</Link></li>)}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-white text-sm uppercase tracking-wider mb-4">{t.footer.contactInfo}</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3"><Icon name="Phone" size={16} className="text-blue" /><a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-blue">{CONTACT.phone}</a></li>
              <li className="flex items-center gap-3"><Icon name="MessageCircle" size={16} className="text-blue" /><a href={whatsappLink()} target="_blank" rel="noreferrer" className="hover:text-blue">WhatsApp</a></li>
              <li className="flex items-center gap-3"><Icon name="Mail" size={16} className="text-blue" /><a href={`mailto:${CONTACT.email}`} className="hover:text-blue break-all">{CONTACT.email}</a></li>
              <li className="flex items-center gap-3"><Icon name="Building2" size={16} className="text-blue" /><span>KVK: {CONTACT.kvk}</span></li>
              <li className="flex items-center gap-3"><Icon name="Clock" size={16} className="text-blue" /><span>{t.footer.hours}: 07:00–20:00</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Sparko. {t.footer.rights}</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
